import React, { useRef, useState } from 'react'
import Webcam from 'react-webcam'
import ReactDOM from 'react-dom'

export const renderCamera = (width, height, isFacingUser) => {
  const placeholder = document.querySelector("#cameraPlaceholder")
  const photoPromise = new Promise((resolve, reject) => {
    ReactDOM.render(<CameraWidget 
      resolvePhoto={resolve} 
      cancelPhoto={reject}
      width={width} 
      height={height}
      isFacingUser={isFacingUser}
    />, placeholder)
  });
  return photoPromise
}

const CameraWidget = ({resolvePhoto, cancelPhoto, width, height, isFacingUser}) => {

  [facing, setFacing] = useState(isFacingUser)

  const webcamRef = useRef(null);
  const capture = React.useCallback(
    () => {
      const imageSrc = webcamRef.current.getScreenshot();
      closeCamera(imageSrc);
    },
    [webcamRef]
  );

  const closeCamera = (image) => {
    if (image) {
      resolvePhoto(image)
    } else {
      cancelPhoto(new stratego.CancelledPhotoError())
    }
    ReactDOM.unmountComponentAtNode(document.querySelector('#cameraPlaceholder'));
  }

  const videoConstraints = {
    width: width,
    height: height,
    facingMode: facing ? "user" : "environment"
  };

  return (
    <div className="CameraWidget">
      <div className="camera-container">
        <div className="row">
          <div className="spacer"></div>
          <div className="spacer"></div>
          <button onClick={() => closeCamera(null)}>
            <img className="close" src="/art/workshop/close_btn__active.png" />
          </button>
        </div>
        <Webcam
          audio={false}
          height={height}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          width={height}
          videoConstraints={videoConstraints}
        />
        <div className="row">
          <div className="spacer"></div>
          <button className="capture" onClick={capture} />
          <button className="direction" onClick={() => setFacing(!facing)}>
            <img src="/art/workshop/arrow-circle-3.svg" />
          </button>
        </div>
      </div>
    </div>
  );
};
